export const LineIcon = (color?: string): React.ReactElement => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_373_194684)">
        <path
          d="M12.6667 5.33333V10.6667C12.6667 10.8435 12.5964 11.013 12.4714 11.1381C12.3464 11.2631 12.1768 11.3333 12 11.3333H3.99999C3.82318 11.3333 3.65361 11.2631 3.52859 11.1381C3.40357 11.013 3.33333 10.8435 3.33333 10.6667V5.33333C3.33333 5.15652 3.40357 4.98695 3.52859 4.86193C3.65361 4.7369 3.82318 4.66666 3.99999 4.66666H12C12.1768 4.66666 12.3464 4.7369 12.4714 4.86193C12.5964 4.98695 12.6667 5.15652 12.6667 5.33333Z"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.66667 14.6667V14C4.66667 13.8232 4.73691 13.6536 4.86193 13.5286C4.98696 13.4036 5.15653 13.3333 5.33334 13.3333H10.6667C10.8435 13.3333 11.0131 13.4036 11.1381 13.5286C11.2631 13.6536 11.3333 13.8232 11.3333 14V14.6667"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.3333 1.33334V2C11.3333 2.17681 11.2631 2.34638 11.1381 2.47141C11.0131 2.59643 10.8435 2.66667 10.6667 2.66667H5.33334C5.15653 2.66667 4.98696 2.59643 4.86193 2.47141C4.73691 2.34638 4.66667 2.17681 4.66667 2V1.33334"
          stroke={color ?? '#303E47'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_373_194684">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
